import {styled} from "@mui/material/styles"

export const LoadingIconContainer = styled("div")`
    img {
        width: 3rem;
        height: 3rem;
    }
`
export default LoadingIconContainer
